import { REQUEST_CREATE_SKILL, RECEIVE_CREATE_SKILL, UPDATE_CREATE_SKILL_VALUES, CLEAR_CREATE_SKILL_VALUES } from '../constants/actionTypes';
import { getBody, displayError } from './helpers';
import { hideCreateSkillModal } from './modal';
import { getBackendUrl } from '../env';


export const requestCreateSkill = () => ({
    type: REQUEST_CREATE_SKILL
})

export const receiveCreateSkill = (result) => ({
    type: RECEIVE_CREATE_SKILL,
    result: result
})

export const updateCreateSkillFormValues = values => ({
    type: UPDATE_CREATE_SKILL_VALUES,
    values: values
})

export const clearCreateSkillModalValues = () => ({
    type: CLEAR_CREATE_SKILL_VALUES
})

export const canCreateSkill = (state) => {
    if(state == null){
        return false;
    }

    return true;
}

export const createSkill = (state) => dispatch => {
    if(!canCreateSkill(state)){
        return false;
    }

    dispatch(requestCreateSkill()); // Flag to the application that we have started our request.

    //
    // Create our request's body
    //

    const payload = {
        skillName:  state.skillName,
        skillGroupName: state.skillGroup,
        skillType:  state.skillType
    };

    //
    // Send our request off.
    //

    console.log("state in createSkill action: ", state);

    (fetch(`${getBackendUrl()}/api/v1/data/skills/skills`, {method: 'POST', body: JSON.stringify(payload), headers: {'Content-Type': 'application/json'}})
        .then(getBody)
        .then(json => {
            dispatch(receiveCreateSkill(json));
            dispatch(clearCreateSkillModalValues());
            dispatch(hideCreateSkillModal());
        }))
        .catch(err => {
            dispatch(receiveCreateSkill(null));
            dispatch(displayError(err));
        });
}



// WEBPACK FOOTER //
// ./src/actions/createSkill.js